import { render, staticRenderFns } from "./AppCurrentPlanLimitsRestrictionsAlert.vue?vue&type=template&id=567f0003"
import script from "./AppCurrentPlanLimitsRestrictionsAlert.vue?vue&type=script&lang=js"
export * from "./AppCurrentPlanLimitsRestrictionsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports